import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BaseService } from 'src/app/common/base/base.service';
import { AcceleratorCatalog } from '../../catalogs/accelerator-catalog/services/accelerator-catalog';

export interface AcceleratorStatus {
  id: number;
  name: string;
  status: string;
  documents: string[];
  moreInfo?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AcceleratorCatalogService extends BaseService<AcceleratorCatalog, number> {

  constructor(
    protected override injector: Injector,
  ) {
    super(injector, '/AcceleratorCatalog');
  }

  getAcceleratorStatus(): Observable<AcceleratorStatus[]> {
    return this.http.get<AcceleratorStatus[]>(environment.urls.baseApiUrl + '/AcceleratorStatus');
  }
}
